module.exports = __webpack_public_path__ + "static/media/ace2.52ae1540.png";